import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ProgramService} from "@catmodels/programs/services/program.service";

const publicComponents = [];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
  ProgramService
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class ProgramsModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/programs/programs.module.ts